__turbopack_context__.v({
  "latest_news_thumbnail": "LatestNewsThumbnail-module-scss-module__Xdv-3q__latest_news_thumbnail",
  "latest_news_thumbnail_image": "LatestNewsThumbnail-module-scss-module__Xdv-3q__latest_news_thumbnail_image",
  "latest_news_thumbnail_overlay": "LatestNewsThumbnail-module-scss-module__Xdv-3q__latest_news_thumbnail_overlay",
  "latest_news_thumbnail_overlay_source": "LatestNewsThumbnail-module-scss-module__Xdv-3q__latest_news_thumbnail_overlay_source",
  "latest_news_thumbnail_overlay_story": "LatestNewsThumbnail-module-scss-module__Xdv-3q__latest_news_thumbnail_overlay_story",
  "latest_news_thumbnail_wrapper": "LatestNewsThumbnail-module-scss-module__Xdv-3q__latest_news_thumbnail_wrapper",
});
